export default __webpack_public_path__ + "static/healthcare-5c46e6e1a8ef83fc79108029a8d975c4.jpg";